import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FiCompareHtmlService } from '@fi-app/utilities/compare-html/compare-html.service';

@Component({
    selector: 'fi-agreement-version-view',
    templateUrl: './agreement-version-view.component.html',
    standalone: false,
})
export class FiAgreementVersionViewComponent implements AfterViewInit {
    @Input() versionModel;
    @Input() activeVersion;

    @Input() activeVersionModel;
    @Output() activeVersionModelChange = new EventEmitter();

    onActiveVersionModelChange($event) {
        this.activeVersionModelChange.emit($event);
    }

    @Input() compareWith: FiAgreementVersionViewComponent;
    @ViewChild('compareHtml', { static: false }) compareHtml: ElementRef;

    constructor(private compareHtmlService: FiCompareHtmlService) {}

    ngAfterViewInit() {
        this._compareHtml();
    }

    protected _compareHtml() {
        if (!this.compareWith || !this.compareWith.compareHtml || !this.compareHtml) {
            return;
        }

        this.compareHtmlService.compareNodes(
            this.compareWith.compareHtml.nativeElement,
            this.compareHtml.nativeElement,
        );
    }
}
